import React from "react";
import { AppBar, TitlePortal } from "react-admin";
import TicketNotificationBell from "./TicketNotificationBell";

export default function CustomAppBar(props) {
  return (
    <AppBar {...props}>
      <TitlePortal />
      <TicketNotificationBell />
    </AppBar>
  );
}
